import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_mst_coupon_line_scan_event_RowClass} from '../../../dbschema/bl_fi_mst_coupon_line_scan_event.model';

export class CouponLineScanEventContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_line_scan_event: bl_fi_mst_coupon_line_scan_event_RowClass;
}
